import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-end">— son —</div>
      <div className="footer-email">ddiasarchive@gmail.com</div>
    </footer>
  );
};

export default Footer;
